import { render } from "./UserTermsView.vue?vue&type=template&id=e2a926d4"
import script from "./UserTermsView.vue?vue&type=script&lang=js"
export * from "./UserTermsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__